import React from 'react';
import { useNavigate } from 'react-router-dom';

const PLAN_FEATURES = {
  pro: {
    label: 'Pro',
    price: '200',
    features: [
      'Dashboard pilotage en temps réel',
      'Scorecard qualité & conformité',
      'Rapports automatiques',
      'Agent Conformité IA inclus',
      'Statistiques avancées',
    ],
  },
  enterprise: {
    label: 'Enterprise',
    price: '500',
    features: [
      'Tout le plan Pro inclus',
      'Prévisions & forecasting',
      'Benchmarking sectoriel',
      'API & webhooks avancés',
      'Connecteurs Zendesk / Intercom',
      'SLA garanti',
    ],
  },
};

export default function LockedPage({ requiredPlan, currentPlan }) {
  const navigate = useNavigate();
  const plan = PLAN_FEATURES[requiredPlan] || PLAN_FEATURES.pro;

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh' }}>
      <div style={{
        background:'#fff', border:'1px solid rgba(0,0,0,0.07)', borderRadius:'16px',
        padding:'2.5rem', maxWidth:'440px', width:'100%', textAlign:'center',
        boxShadow:'0 2px 12px rgba(0,0,0,0.04)',
      }}>
        {/* Lock icon */}
        <div style={{
          width:'48px', height:'48px', borderRadius:'50%',
          background:'rgba(184,134,11,0.1)', border:'1px solid rgba(184,134,11,0.2)',
          display:'flex', alignItems:'center', justifyContent:'center',
          margin:'0 auto 1.25rem', fontSize:'20px',
        }}>
          🔒
        </div>

        <div style={{
          fontFamily:'Syne, sans-serif', fontSize:'18px', fontWeight:600,
          color:'#1A1916', marginBottom:'8px',
        }}>
          Fonctionnalité {plan.label}
        </div>

        <div style={{
          fontSize:'13px', color:'rgba(26,25,22,0.5)', lineHeight:1.6, marginBottom:'1.5rem',
        }}>
          Cette page est disponible avec le plan <strong style={{ color:'#B8860B' }}>{plan.label}</strong>.
          Passez à {plan.label} pour débloquer ces fonctionnalités.
        </div>

        {/* Features list */}
        <div style={{
          background:'#F5F3EE', borderRadius:'10px', padding:'1rem 1.25rem',
          textAlign:'left', marginBottom:'1.5rem',
        }}>
          <div style={{ fontSize:'11px', fontWeight:600, color:'#B8860B', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'10px' }}>
            Inclus dans {plan.label} — {plan.price} €/mois
          </div>
          {plan.features.map((f, i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:'8px', padding:'4px 0', fontSize:'12px', color:'#1A1916' }}>
              <span style={{ color:'#B8860B', fontSize:'14px' }}>✓</span>
              <span>{f}</span>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate('/facturation')}
          style={{
            background:'#B8860B', color:'#fff', border:'none',
            padding:'10px 28px', borderRadius:'8px', fontSize:'13px',
            fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans', sans-serif",
            transition:'opacity 0.15s',
          }}
          onMouseEnter={e => e.target.style.opacity = '0.85'}
          onMouseLeave={e => e.target.style.opacity = '1'}
        >
          Changer de plan
        </button>

        <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.3)', marginTop:'12px' }}>
          Votre plan actuel : {currentPlan?.charAt(0).toUpperCase() + currentPlan?.slice(1) || 'Starter'}
        </div>
      </div>
    </div>
  );
}
